// extracted by mini-css-extract-plugin
export var outlinedButton = "button-module--outlinedButton--459cf";
export var white = "button-module--white--71e43";
export var wide = "button-module--wide--0ff55";